import { useTranslation } from "react-i18next";

/**
 * The WSL Notion wordmark for the board-blue bands (sign-in, session checks,
 * no access): the name and the tagline. `board` on blue, `paper` on white.
 */
export function Wordmark({ tone = "board", compact = false }: { tone?: "board" | "paper"; compact?: boolean }) {
	const { t } = useTranslation();
	return (
		<span className="flex min-w-0 items-baseline gap-[0.5rem] whitespace-nowrap">
			<span className={`font-black leading-none tracking-[-0.01em] ${compact ? "text-[1rem]" : "text-[1.25rem]"} ${tone === "board" ? "text-white" : "text-board"}`}>
				{t("app.wordmark")}
			</span>
			{!compact && <span className={`truncate text-[0.75rem] ${tone === "board" ? "text-white/75" : "text-muted"}`}>{t("app.tagline")}</span>}
		</span>
	);
}
